import dayjs from 'dayjs';
import { DATEFORMAT_LOCAL_STATE } from '@ps20-frontend/utils';
import { Selbstbeteiligung, Zahlungsart, Zahlweise } from '@ps20/bff-models';
import { IAppState } from './appState';
import { emptyGegenstand } from './reducers/gegenstandsschutz.reducer';

export const INITIAL_STATE: IAppState = {
  version: 4,
  antragsnummer: null,
  angebotsId: null,
  rabattstufe: 0,
  taasInfo: {
    hashedTaasRequest: '',
    hashedRiskData: '',
    rbdNachlass: 0,
    tbNachlass: 0,
    savedRbdNachlass: 0,
    savedTbNachlass: 0,
    savedAktionsnachlass: 0,
    anpassungsFaktor: 0,
    specialInfo: {
      aktionsnachlass: 0,
      erhrisiko: 0,
      nachlman: 0,
      zuschlman: 0,
    },
  },
  versicherungsnehmer: {
    geburtsdatum: '',
    isAssekuranztarif: false,
    adresse: null,
  },
  transientState: {
    zurueckZumShopModalOpen: false,
    role: null,
    featureToggles: {},
    regexps: {},
    tarifierungIsInProgress: false,
    priceGuarantee: false,
    kooperationen: null,
  },
  vertragsoptionen: {
    selbstbeteiligung: Selbstbeteiligung.SELBSTBETEILIGUNG_0000,
    zahlungsweise: Zahlweise.MONATLICH,
    vertragslaufzeit: 3,
    ausgewaehltevertragslaufzeit: 3,
    zahlungsart: Zahlungsart.LASTSCHRIFT,
    beginnDatum: dayjs().add(1, 'd').format(DATEFORMAT_LOCAL_STATE),
    aenderungdatum: dayjs().add(1, 'd').format(DATEFORMAT_LOCAL_STATE),
    vorversicherungVorhanden: true,
  },
  produkt: null,
  gegenstandsschutz: {
    items: [emptyGegenstand()],
    categories: null,
  },
  jahresbeitrag: 0,
  gesamtbeitrag: 0,
  gesamtbeitragMitRabatt: 0,
  savedGesamtbeitragMitRabatt: 0,
  savedJahresbeitragMitRabatt: 0,
  fahrradVorschaeden: {
    provided: null,
    count: 0,
    manuallyEntered: false,
  },
};
